// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum EscalatorGroupSupervisoryStatus {
  UpPeak = 0,
  DownPeak = 1,
  Fire = 2,
  EmergencyPower = 3,
  PH1 = 4,
  HcPower = 5,
  HcComm = 6,
  Sec = 7,
  Normal = 8,
  Epd = 9,
  Evacuation = 10,
  Standby = 11
}
